const flyersApi = '/api/promotion-flyer';

export { flyersApi };
